@if (link != null) {
<a [routerLink]="link"><figure></figure></a>
} @if (link == null) {
<figure></figure>
}
